var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#search_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9.4c0-2.24 0-3.36.436-4.216a4 4 0 011.748-1.748C7.04 3 8.16 3 10.4 3h19.2c2.24 0 3.36 0 4.216.436a4 4 0 011.748 1.748C36 6.04 36 7.16 36 9.4v19.2c0 2.24 0 3.36-.436 4.216a4 4 0 01-1.748 1.748C32.96 35 31.84 35 29.6 35H10.4c-2.24 0-3.36 0-4.216-.436a4 4 0 01-1.748-1.748C4 31.96 4 30.84 4 28.6V9.4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.922 22.401l-2.209-2.236a4.08 4.08 0 00.547-2.028A4.14 4.14 0 0019.13 14 4.14 4.14 0 0015 18.137a4.14 4.14 0 004.13 4.137c.727 0 1.446-.2 2.086-.583l2.198 2.228a.264.264 0 00.38 0l1.128-1.14a.267.267 0 000-.378zm-5.792-6.79a2.525 2.525 0 010 5.051 2.525 2.525 0 010-5.05z",
    fill: "#32324D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "search_svg__filter0_d",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.102907 0 0 0 0 0.102907 0 0 0 0 0.261974 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default "/_next/static/images/172f71ebb55cd6918e8d6570368f49ae.svg";
export { ForwardRef as ReactComponent };